import {createContext} from 'react';

export const TitleContext = createContext<{setTitle: (title: string) => void}>({setTitle: (title: string) => {}});
